import React, { useState } from 'react';
import Product from '../Product';
import {ProductGroup, NeuroMessage, ProductPagePropTypes, usePages, AppContext} from '@ignitesales/neuro-application/src/neuro-guide';
import { AnswersList } from '@ignitesales/neuro-application/src/neuro-guide/guide-framework';
import ContactFormModal from '../modals/ContactFormModal';
import SuccessFormModal from '../modals/SuccessFormModal';
import ShareViaEmailModal from '../modals/ShareViaEmailModal';
import ShareViaEmailComplete from '../modals/ShareViaEmailComplete';
import ShareViaSmsModal from '@ignitesales/neuro-application/src/neuro-guide/components/ShareViaSmsModal';
import PrintButton from '@ignitesales/neuro-application/src/neuro-guide/components/PrintButton';
import { useUser } from '@ignitesales/neuro-application/src/neuro-guide/hooks';
import { sendResultsViaEmail, useDispatch } from '@ignitesales/neuro-application/src/neuro-guide/state';
import Collapsible from 'react-collapsible';
import ReactSVG from "react-svg";

import Cart from "../Cart";
import CartButton from "../CartButton";


function SummaryPage({ componentClass, productGroups }) {
  const { goToPreviousPage } = usePages();
  const { uuid } = useUser();
  const [ showContactFormModal, setShowContactFormModal ] = useState(false);
  const [ showShareViaSmsModal, setShowShareViaSmsModal ] = useState(false);
  const [ showShareViaEmailModal, setShowShareViaEmailModal ] = useState(false);
  const [ showShareViaEmailComplete, setShowShareViaEmailComplete ] = useState(false);
  const [ showSuccessFormModal, setShowSuccessFormModal ] = useState(false);
  const [ selectedProduct, setSelectedProduct ] = useState({});
  const [ currentLead, setCurrentLead ] = useState({});
  const [ leadTransmitted, setLeadTransmitted ] = useState(false);
  const [ onEmailSubmission, setOnEmailSubmission ] = useState(false);
  const [ showCart, setShowCart ] = useState(false);
  const [ productsInCart, setProductsInCart ] = useState();
  const dispatch = useDispatch();
  const date = new Date();


  const triggerContactForm = () => {
    if( !leadTransmitted ) {
      setShowContactFormModal(true);
      setShowCart(false);
    } else {
      setLeadTransmitted(true);
    }
  }

  const renderProductCart = (
    <Cart
      className={`${componentClass}__productCart`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showCart}
      onClose={() => setShowCart(false)}
      lead={ currentLead }
      triggerContactForm={ triggerContactForm }
      leadTransmitted={ leadTransmitted }
    />
  );

  const renderProductGroup = (productGroup, subGroups, products) => {
    const cssBEM = 'product-group';

    return products.length ?
      <div className={cssBEM}>
        <div className={ `${ cssBEM }__container` } key={ productGroup.name }>
          <div className={ `${ cssBEM }__header count-${ products.length || 0 }` }>
            <h1><NeuroMessage id={ `productGroup.${ productGroup.name }` } tagName="span"/></h1>
          </div>
          { subGroups || null }
          { products || null }
        </div>
      </div> : null;
  };

  const onProductClick = (params) => {
    setSelectedProduct(params);
  };

  const currentCartCount = (cartNumber) => {
    setProductsInCart(cartNumber);
  }

  const onCartClick = () => {
    !leadTransmitted ? triggerContactForm() : setShowCart(true);
  }

  const onContactSuccess = (lead) => {
    setShowContactFormModal(false);
    setShowCart(true);
    setLeadTransmitted(true);
    setCurrentLead(lead);

    const sendEmailParams = {
      email: lead.email,
      fromEmail: null,
      copyMe: false,
    };

    if( !onEmailSubmission ) {
      dispatch(sendResultsViaEmail(sendEmailParams));
    }
  };

  const onSuccessAction = () => {
    setShowSuccessFormModal(false);
    setShowCart(true);
  };

  const onEmailComplete = () => {
    setOnEmailSubmission(true);
  };

  const renderProduct = (product) => {
    return <Product
      key={ product.id }
      product={ product }
      onClick={ onProductClick }
    />;
  };

  const contactFormModal = (
    <ContactFormModal
      className={`${componentClass}__contactModal contactForm`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showContactFormModal}
      onClose={() => setShowContactFormModal(false)}
      onComplete={ onContactSuccess }
      selectedProduct= { selectedProduct }
    />
  );

  const successFormModal = (
    <SuccessFormModal
      className={ `${componentClass}__successFormModal` }
      closeBtn={ <i className={'fa fa-times'} /> }
      isOpen={ showSuccessFormModal }
      onClose={ () => setShowSuccessFormModal(false) }
      onSuccessModalClose={ onSuccessAction }
      selectedProduct= { selectedProduct }
      lead={ currentLead }
    />
  );

  const shareViaSmsModal = (
    <ShareViaSmsModal
      className={`${componentClass}__smsModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaSmsModal}
      onClose={() => setShowShareViaSmsModal(false)}
    />
  );

  const shareViaEmailModal = (
    <ShareViaEmailModal
      className={`${componentClass}__emailModal shareModal`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaEmailModal}
      onClose={() => setShowShareViaEmailModal(false)}
      onEmailComplete={onEmailComplete}
    />
  );

  const shareViaEmailComplete = (
    <ShareViaEmailComplete
      className={`${componentClass}__emailModal emailComplete`}
      closeBtn={<i className={'fa fa-times'} />}
      isOpen={showShareViaEmailComplete}
      onClose={() => setShowShareViaEmailComplete(false)}
    />
  );

  return (
    <div className={componentClass}>
      <div className={ `${ componentClass }__header` }>
        <div className={ `${ componentClass }__header--container` }>
          <NeuroMessage id="summary.header" tagName='h1' />
        </div>
      </div>

      <div className={ `${ componentClass }__uuidMessage` }>
        <NeuroMessage id="summary.uuidMessage" tagName='p' values={{ uuid: uuid, date: date.toDateString() }} />
      </div>

      <div className={ `${ componentClass }__products` }>{ productGroups.map(g =>
        <ProductGroup group={ g } renderGroupFn={ renderProductGroup } renderProductFn={ renderProduct } key={ g.name } />
      )}
      </div>

      <div className={ `${ componentClass }__answers` }>
        <Collapsible
          classParentString="collapsible"
          className={`${ componentClass }__answer-collapsible`}
          openedClassName={`${ componentClass }__answers-collapsible--open`}
          trigger={
            <NeuroMessage id="summary.answers" tagName='h2' />
          }>
          <AnswersList />
        </Collapsible>
      </div>

      <div className={ `${ componentClass }__navigation` }>
        <button onClick={goToPreviousPage} className="btn btn-secondary"><NeuroMessage id="nav.prev"/></button>
      </div>
      <div className={ `${ componentClass }__footer` }>
       <div>© {new Date().getFullYear()} <NeuroMessage id="summary.footer" tagName='p'/></div>
        <ReactSVG src="/classpath/assets/images/equal-housing-logo.svg" />
      </div>

      <div className={ `${ componentClass }__actionBar` }>
        <div className="actions">

            <CartButton
                onCartClick={ onCartClick }
                currentCartCount={ currentCartCount }
            />

            <div className="email action" onClick={ onEmailSubmission || leadTransmitted ? () => { setShowShareViaEmailComplete(true); } : () => { setShowShareViaEmailModal(true); } }>
              <span className="fa fa-envelope"/>
              <NeuroMessage id="summary.email" tagName='h5' />
            </div>

            <div className="sms action" onClick={() => { setShowShareViaSmsModal(true); }}>
              <span className="fa fa-mobile"/>
              <NeuroMessage id="summary.mobile" tagName='h5' />
            </div>

            <PrintButton className="print action" tagName="div" shouldOpenDetailsPage={true}>
              <span className="fa fa-print"/>
              <NeuroMessage id="summary.print" tagName='h5' />
            </PrintButton>
        </div>
      </div>

      { renderProductCart }
      { contactFormModal }
      { shareViaSmsModal }
      { shareViaEmailModal }
      { shareViaEmailComplete }
      { successFormModal }

    </div>
  );
}

SummaryPage.propTypes = ProductPagePropTypes;

export default SummaryPage;
